import React, { useEffect, useState } from 'react';
import { ArrowUp } from '@phosphor-icons/react';

/**
 * Floating "Back to top" button. Appears when the user scrolls > threshold pixels
 * and smoothly returns them to the top on click.
 *
 * Usage: <BackToTop /> — drop into any long-scroll page.
 */
export const BackToTop = ({ threshold = 400 }) => {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const onScroll = () => setVisible(window.scrollY > threshold);
    onScroll();
    window.addEventListener('scroll', onScroll, { passive: true });
    return () => window.removeEventListener('scroll', onScroll);
  }, [threshold]);

  return (
    <button
      type="button"
      onClick={() => window.scrollTo({ top: 0, behavior: 'smooth' })}
      aria-label="Back to top"
      title="Back to top"
      data-testid="back-to-top"
      className={`fixed bottom-6 right-6 z-40 h-11 w-11 rounded-full border border-gold/50 bg-charcoal/90 backdrop-blur-sm text-gold shadow-lg flex items-center justify-center hover:bg-gold hover:text-charcoal transition-all duration-300 ${
        visible ? 'opacity-100 translate-y-0 pointer-events-auto' : 'opacity-0 translate-y-3 pointer-events-none'
      }`}
    >
      <ArrowUp size={18} weight="bold" />
    </button>
  );
};
